<template>
  <Button
    class="p-button-warning"
    icon="pi pi-chevron-left"
    @click="onBack"
    label="ย้อนกลับ"
  ></Button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "BackButton",
  setup() {
    const { onBack } = usePlugin();
    return {
      onBack,
    };
  },
});
</script>

<style></style>
